export default __webpack_public_path__ + "static/media/get-started.2208f4ad.svg";